import React from "react";
import Image from "next/image";
import Link from "next/link";
import BlackLine from "./../../../assets/BlackLine";
import PinkLine from "./../../../assets/PinkLine";
import Arrow from "../../../assets/RightArrow";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

// import googlePlay from "./../../../../public/projects/google_play.png";
// import appStore from "./../../../../public/projects/app_store.png";

export default function index({ color }) {
  const router = useRouter();
  const lang = router.locale;
  const t = useTranslations("ipillion.Download");
  return (
    <>
      <div className="relative w-full xsm:h-[550px]  h-[700px] sm:h-[700px] lg:h-[500px] overflow-hidden ">
        <div className="bg-[#EFBBC0] lg:-skew-y-3 -skew-y-6 z-10 [400px] lg:h-[70px] h-[60px] w-full absolute bottom-0"></div>
        <div className="bg-[#D60014] -skew-y-1 z-20 [400px] h-[60px] w-full absolute -bottom-6"></div>
        <div className=" absolute bottom-0 z-30 flex w-full justify-center items-center  flex-col lg:flex-row mx-auto">
          <div className="max-w-[90rem] w-full lg:mx-auto grid grid-cols-12 lg:px-0 px-[9%]">
            <div className="max-w-[500px] mx-auto lg:col-span-6 col-span-12 ">
              <div>
                <h2 className="lg:font-[590] font-[700] lg:text-[40px] text-[32px] whitespace-nowrap  text-[#1D1D1B]">
                  {t("header")}
                </h2>
                <hr
                  style={{
                    background: color,
                  }}
                  className={`h-[5px] border-none rounded-[22.5px] w-[138px]`}
                ></hr>
              </div>
              <div className="grid grid-cols-12">
                <div className="col-span-12 lg:my-[1rem] gap-y-5 grid grid-cols-12 items-center ">
                  <div className="col-span-12 lg:col-span-6">
                    <p className="whitespace-nowrap text-left max-w-[40%] text-[18px] leading-[25px] font-[590] text-[#1D1D1B]">
                      {t("sub-header")}
                    </p>
                  </div>
                  <div className="col-span-12 lg:col-span-6">
                    <Link href={"/contact"}>
                      <button className="rounded-[47px] border-[#D60014] border-[2px]  w-[188px] h-[48px] flex justify-around items-center">
                        <div>
                          <p className="text-[16px]">{t("button")}</p>
                        </div>
                        <div
                          className={`${
                            lang == "ar" ? "-scale-x-100 pr-3" : "pl-3"
                          }`}
                        >
                          <Arrow />
                        </div>
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="col-span-12 flex justify-start gap-8 my-1">
                  <a
                    href="https://play.google.com/store/apps/details?id=io.ipillionPhase1.android.app"
                    target="_blank"
                  >
                    <div className="lg:w-[189px] w-[178px] h-fit">
                      <Image
                        src={"/projects/android.png"}
                        layout="responsive"
                        width={189}
                        height={56}
                        quality={100}
                        className=" object-cover"
                      />
                    </div>
                  </a>
                  <a
                    href="https://apps.apple.com/jo/app/ipillion/id1575502104"
                    target="_blank"
                  >
                    <div className="w-[189px] h-fit">
                      <Image
                        src={"/projects/ios.png"}
                        layout="responsive"
                        width={189}
                        height={56}
                        quality={100}
                        className=" object-cover"
                      />
                    </div>
                  </a>
                </div>
                <div className="col-span-12">
                  <p className=" text-[#1D1D1B] leading-[25px] text-[18px] font-[510]">
                    {t("visit")}{" "}
                    <span className=" text-[#6D2E88] underline ">
                      <a href="https://ipillion.io/" target="_blank">
                        {t("website")}
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="hidden lg:block relative -mt-5 lg:col-span-6 col-span-12">
              <Image
                src="/projects/iPillion/community.png"
                alt="ipillion Community"
                layout="responsive"
                width={766}
                height={430}
                className="object-cover"
              />
            </div>
            <div className=" lg:hidden relative lg:col-span-6 col-span-12 ">
              <Image
                src="/projects/iPillion/community.png"
                alt="ipillion Community"
                layout="responsive"
                width={404}
                height={227}
                className="object-cover"
                quality={100}
              />
            </div>
          </div>
        </div>
        <div className="bg-black lg:skew-y-2 skew-y-6 z-30 right-3 [400px] lg:h-[60px] h-[50px] w-full -mr-3 -pr-3 absolute -bottom-8"></div>
      </div>
    </>
  );
}
